import React from 'react';
import { EmployerLayout } from '../../JobPostPricing/EmployerLayout';
import EmployerProfilePage from './EmployerProfilePage';
import { ChevronLeft, User } from 'lucide-react';

export const EmployerProfile = () => {
  return (
    <EmployerLayout>
      <div className="flex flex-col w-full gap-6">
        <div className="flex items-center justify-end">
          <div className="flex items-center bg-slate-100 rounded-xl py-2.5 px-4">
            <ChevronLeft className="w-5 h-5 mr-2" />
            <User className="w-5 h-5 ml-2" />
          </div>
        </div>
        <div className="flex flex-1 flex-col gap-8">
          <EmployerProfilePage />
        </div>
      </div>
    </EmployerLayout>
  );
};